import { call, put, takeEvery, select, CallEffect, PutEffect, SelectEffect } from 'redux-saga/effects'
import { adminActions } from './actions'
import adminOrderService from '../../../services/adminOrderService'
import { RootState } from '../../types'
import { selectUser, selectIsAuthenticated } from '../auth/selectors'

/**
 * Saga para buscar contagem de pedidos pendentes
 */
function* fetchPendingOrdersCountSaga(): Generator<CallEffect | PutEffect | SelectEffect, void, any> {
  try {
    // Verificar se o usuário está autenticado e é admin
    const state: RootState = yield select()
    const isAuthenticated = selectIsAuthenticated(state)
    const user = selectUser(state)
    const isAdmin = user?.role === 'ADMIN'
    
    if (!isAuthenticated || !isAdmin) {
      yield put(adminActions.fetchPendingOrdersCountSuccess({ count: 0 }))
      return
    }
    
    const count = yield call(adminOrderService.getPendingCount)
    yield put(adminActions.fetchPendingOrdersCountSuccess({ count }))
  } catch (error: any) {
    const errorStatus = error?.status || error?.response?.status
    
    // Se for erro 401 ou 403, não tentar novamente
    if (errorStatus === 401 || errorStatus === 403) {
      yield put(adminActions.fetchPendingOrdersCountSuccess({ count: 0 }))
      return
    }
    
    const errorMessage = error.response?.data?.message || error.message || 'Erro ao buscar pedidos pendentes'
    yield put(adminActions.fetchPendingOrdersCountFailure({ error: errorMessage }))
  }
}

/**
 * Root saga do módulo Admin
 */
export function* adminSaga(): Generator {
  yield takeEvery(adminActions.fetchPendingOrdersCountRequest.type, fetchPendingOrdersCountSaga)
}

